import { ResultData } from "../Result.modal";
import { useState } from "react";
import {
  LivenessErrorCode,
  LivenessResult,
  LIvenessStatus,
} from "../../../../../constants";

const storageKey = "ONE_KYC_ATTEMPTS";

export const useOneKycAttemptCounter = () => {
  const [count, setCount] = useState<number>(() => {
    const storedCount = localStorage.getItem(storageKey);

    return Number(storedCount);
  });

  const validateAndIncreaseCount = (data: ResultData | null) => {
    const { status, result, errorCode } = data || {};

    const isNotLiveAttempt =
      status === LIvenessStatus.Completed &&
      result === LivenessResult.Invalid &&
      errorCode === LivenessErrorCode.NotLive;

    if (isNotLiveAttempt) {
      const newCount = count + 1;
      setCount(newCount);
      localStorage.setItem(storageKey, newCount.toString());
    }
  };

  return {
    count,
    validateAndIncreaseCount,
  };
};
